import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Tooltip, Typography } from '@material-ui/core';

import { BRIEF_TYPE, contentTypeFromBriefType } from 'src/data/brief';
import { getContentTypeTaxonomyHint, getContentTypeTaxonomyName } from 'src/data/contentType';
import TextLink from 'src/components/TextLink';
import TruncatedTooltip from 'src/components/TruncatedTooltip';
import { EditIcon } from 'src/assets/icons/EditIcon';
import { useStyles } from './useStyles';

export const ButtonScoringMethod = ({
  className,
  classes,
  briefType,
  scoringMethodName,
  onClick,
  readOnly,
}) => {
  const styles = useStyles({ classes });

  const contentType = contentTypeFromBriefType(briefType);
  const displayedName = scoringMethodName || `Undefined ${getContentTypeTaxonomyName(contentType)}`;

  const truncatedTaxonomyWithTooltip = (
    <TruncatedTooltip title={displayedName}>
      {(ref) => (
        <span
          className={styles.name}
          ref={ref}
        >
          {displayedName}
        </span>
      )}
    </TruncatedTooltip>
  );

  return (
    <div className={cx(styles.root, className)}>
      {readOnly ? (
        <Typography className={styles.taxonomy}>{truncatedTaxonomyWithTooltip}</Typography>
      ) : (
        <Tooltip title={getContentTypeTaxonomyHint(contentType)}>
          <TextLink
            className={cx(styles.taxonomy, styles.link)}
            onClick={onClick}
          >
            {truncatedTaxonomyWithTooltip}
            <EditIcon className={styles.icon} />
          </TextLink>
        </Tooltip>
      )}
    </div>
  );
};

ButtonScoringMethod.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  briefType: PropTypes.oneOf(Object.values(BRIEF_TYPE)).isRequired,
  scoringMethodName: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
};
ButtonScoringMethod.defaultProps = {
  className: '',
  classes: null,
  scoringMethodName: '',
  readOnly: false,
};
